import { BookingPage } from 'types/booking';

export function createBookingPage(): BookingPage {
  return {
    startLineDate: new Date(),
    selectedDateISO: new Date().toISOString()
  };
}
